// extracted by mini-css-extract-plugin
export var currencyInput = "_it-1";
export var currencySymbol = "_it-0";